import { createSelector } from 'reselect'
import qs from 'qs'

import {
  categoryRefinementsSelector,
  nonDefaultAttributeRefinementIdsSelector,
  keywordRefinementSelector,
  collectionRefinementSelector,
} from '~/app/store/refinement/selectors'
import { nonDefaultPageSelector, nonDefaultPageSizeSelector } from '~/app/store/paging/selectors'
import { updateQuery } from '~/app/store/locationState/utils'
import { getIsL1orL2 } from '~/app/store/config'
import { getQuickViewId } from '~/app/store/debug'
import { REFINEMENT_DIMENSION } from 'shared/constants'

export const selectQueryState = createSelector(
  nonDefaultAttributeRefinementIdsSelector,
  categoryRefinementsSelector,
  keywordRefinementSelector,
  collectionRefinementSelector,
  nonDefaultPageSelector,
  nonDefaultPageSizeSelector,
  getIsL1orL2,
  getQuickViewId,
  (_state: State.GlobalState, options?: { isRedirectToL0?: boolean }) => options?.isRedirectToL0,
  (
    attributeIds,
    categories,
    keyword,
    collection,
    page: number | null,
    pageSize: number | null,
    isL1orL2,
    quickViewId,
    isRedirectToL0,
  ): Gallery.Models.Url.SelectQueryState => ({
    parameters: {
      page,
      pageSize,
      [REFINEMENT_DIMENSION.ATTRIBUTE_PLURAL]: attributeIds.map((attr) => attr),
      [REFINEMENT_DIMENSION.CATEGORY_PLURAL]: isL1orL2 && !isRedirectToL0 ? [] : categories.map((attr) => attr.value),
      [REFINEMENT_DIMENSION.KEYWORD]: keyword ? keyword.value : null,
      [REFINEMENT_DIMENSION.COLLECTION]: collection ? collection.value : null,
      qv: quickViewId,
    },
    replace: keyword && !!keyword.replace,
  }),
)

export function selectQueryString(newQueryState: Gallery.Models.Url.SelectQueryState, queryString: string): string {
  const query = { ...qs.parse(queryString, { ignoreQueryPrefix: true }) }

  for (const [key, value] of Object.entries(newQueryState.parameters)) {
    updateQuery(key, value, query)
  }
  return Object.keys(query).length ? `?${qs.stringify(query, { arrayFormat: 'comma' })}` : ''
}
